const playlistTypeOptions = [
    {value: "live_tv", label: "Live TV"},
    {value: "sports", label: "Sports"},
    {value: "events", label: "Events & PPV"},
    {value: "vod", label: "VOD"},
    {value: "svod_movies", label: "VOD Movies (Legacy)"},
    {value: "svod_series", label: "VOD Series (Legacy)"}
];

const playlistDeliveryOptions = [
    {value: "hybrid", label: "OTT + IPTV"},
    {value: "ott", label: "OTT Only"},
    {value: "iptv", label: "IPTV Only"}
];

const viewershipModeOptions = [
    {value: "packages", label: "Package Controlled"},
    {value: "properties", label: "Property / Dealer Restricted"},
    {value: "geo", label: "Geo Restricted"},
    {value: "open", label: "Open Access"}
];

const categoryScopeOptions = [
    {value: "global", label: "Global"},
    {value: "property", label: "Property Scoped"},
    {value: "dealer", label: "Dealer Scoped"}
];

const activePlaylistCategoryRows = [
    {
        playlist_category_id: 201,
        playlist_category_position: 1,
        playlist_category_status: 1,
        playlist_category_name: "Homepage Rails",
        playlist_category_description: "Editorial rails used on the main landing surfaces.",
        playlist_type: "sports",
        playlist_category_scope: "global",
        playlist_count: 3
    },
    {
        playlist_category_id: 202,
        playlist_category_position: 2,
        playlist_category_status: 1,
        playlist_category_name: "Sports Highlights",
        playlist_category_description: "Short-form weekend and event highlight collections.",
        playlist_type: "sports",
        playlist_category_scope: "global",
        playlist_count: 2
    },
    {
        playlist_category_id: 203,
        playlist_category_position: 3,
        playlist_category_status: 1,
        playlist_category_name: "Featured Events",
        playlist_category_description: "Rotating PPV and live-event promo playlists.",
        playlist_type: "events",
        playlist_category_scope: "property",
        playlist_count: 2
    },
    {
        playlist_category_id: 204,
        playlist_category_position: 4,
        playlist_category_status: 1,
        playlist_category_name: "Movie Collections",
        playlist_category_description: "Studio or promo-driven SVOD movie shelves.",
        playlist_type: "svod_movies",
        playlist_category_scope: "global",
        playlist_count: 3
    },
    {
        playlist_category_id: 205,
        playlist_category_position: 5,
        playlist_category_status: 1,
        playlist_category_name: "Series Marathons",
        playlist_category_description: "Binge-focused SVOD series groupings.",
        playlist_type: "svod_series",
        playlist_category_scope: "global",
        playlist_count: 2
    }
];

const removedPlaylistCategoryRows = [
    {
        playlist_category_id: 299,
        playlist_category_position: 9,
        playlist_category_status: 0,
        playlist_category_name: "Legacy Seasonal",
        playlist_category_description: "Old holiday grouping kept for reference during migration.",
        playlist_type: "svod_movies",
        playlist_category_scope: "global",
        playlist_count: 1
    }
];

const activePlaylistRows = [
    {
        playlist_id: 101,
        playlist_position: 1,
        playlist_status: 1,
        playlist_name: "Weekend Sports Spotlight",
        playlist_slug: "weekend-sports-spotlight",
        playlist_description: "Curated sports highlights for the weekend launcher rail.",
        playlist_type: "sports",
        playlist_delivery: "hybrid",
        playlist_category_ids: [201, 202],
        playlist_item_count: 12,
        playlist_viewership_mode: "packages",
        playlist_viewership_summary: "Sports Plus and Premium packages",
        playlist_geo_policy: "US, Canada",
        playlist_device_targets: "Android TV, Roku, Web",
        playlist_sort_mode: "manual",
        playlist_max_items: 20,
        updated_at: "2026-03-15"
    },
    {
        playlist_id: 102,
        playlist_position: 2,
        playlist_status: 1,
        playlist_name: "Friday Fight Night",
        playlist_slug: "friday-fight-night",
        playlist_description: "Event-based playlist for fight-week promos and replay rails.",
        playlist_type: "events",
        playlist_delivery: "hybrid",
        playlist_category_ids: [201, 203],
        playlist_item_count: 8,
        playlist_viewership_mode: "properties",
        playlist_viewership_summary: "Dealer-selected hospitality properties",
        playlist_geo_policy: "United States only",
        playlist_device_targets: "Android TV, STB",
        playlist_sort_mode: "schedule",
        playlist_max_items: 12,
        updated_at: "2026-03-14"
    },
    {
        playlist_id: 103,
        playlist_position: 3,
        playlist_status: 1,
        playlist_name: "Oscar Winners Collection",
        playlist_slug: "oscar-winners-collection",
        playlist_description: "Premium movie playlist for awards-season curation.",
        playlist_type: "svod_movies",
        playlist_delivery: "ott",
        playlist_category_ids: [204],
        playlist_item_count: 24,
        playlist_viewership_mode: "packages",
        playlist_viewership_summary: "SVOD Gold package",
        playlist_geo_policy: "Global except blocked territories",
        playlist_device_targets: "iOS, Android, Web, Android TV",
        playlist_sort_mode: "editorial",
        playlist_max_items: 30,
        updated_at: "2026-03-13"
    },
    {
        playlist_id: 104,
        playlist_position: 4,
        playlist_status: 1,
        playlist_name: "Series Marathon Picks",
        playlist_slug: "series-marathon-picks",
        playlist_description: "Long-form binge playlist for top episodic content.",
        playlist_type: "svod_series",
        playlist_delivery: "ott",
        playlist_category_ids: [205],
        playlist_item_count: 16,
        playlist_viewership_mode: "open",
        playlist_viewership_summary: "All authenticated customers",
        playlist_geo_policy: "Global",
        playlist_device_targets: "Web, Mobile, Connected TV",
        playlist_sort_mode: "popularity",
        playlist_max_items: 18,
        updated_at: "2026-03-11"
    }
];

const removedPlaylistRows = [
    {
        playlist_id: 150,
        playlist_position: 10,
        playlist_status: 0,
        playlist_name: "Legacy Boxing Archive",
        playlist_slug: "legacy-boxing-archive",
        playlist_description: "Deprecated archive rail kept as a migration example.",
        playlist_type: "events",
        playlist_delivery: "iptv",
        playlist_category_ids: [203],
        playlist_item_count: 6,
        playlist_viewership_mode: "packages",
        playlist_viewership_summary: "Legacy PPV subscribers",
        playlist_geo_policy: "United States only",
        playlist_device_targets: "STB",
        playlist_sort_mode: "manual",
        playlist_max_items: 10,
        updated_at: "2026-02-28"
    }
];

const playlistAssignments = {
    101: [
        {playlist_order: 1, content_type: "Sport Event", content_id: "SE-441", content_title: "Athens Derby Countdown", category_name: "Sports Highlights", availability: "Premium"},
        {playlist_order: 2, content_type: "Sport Event", content_id: "SE-442", content_title: "UEFA Late Match Highlights", category_name: "Sports Highlights", availability: "Sports Plus"},
        {playlist_order: 3, content_type: "Sport Event", content_id: "SE-443", content_title: "NBA Weekly Top Plays", category_name: "Homepage Rails", availability: "Premium"}
    ],
    102: [
        {playlist_order: 1, content_type: "Live Event", content_id: "EV-781", content_title: "Friday Main Card", category_name: "Featured Events", availability: "PPV Package"},
        {playlist_order: 2, content_type: "Live Event", content_id: "EV-782", content_title: "Prelims Replay", category_name: "Featured Events", availability: "PPV Package"},
        {playlist_order: 3, content_type: "Live Event", content_id: "EV-783", content_title: "Fighter Interviews", category_name: "Homepage Rails", availability: "Property Bundle"}
    ],
    103: [
        {playlist_order: 1, content_type: "Movie", content_id: "MV-1011", content_title: "The Sound of Winter", category_name: "Movie Collections", availability: "SVOD Gold"},
        {playlist_order: 2, content_type: "Movie", content_id: "MV-1012", content_title: "Midnight Harbor", category_name: "Movie Collections", availability: "SVOD Gold"},
        {playlist_order: 3, content_type: "Movie", content_id: "MV-1013", content_title: "Glass City", category_name: "Movie Collections", availability: "SVOD Gold"}
    ],
    104: [
        {playlist_order: 1, content_type: "Series", content_id: "SR-551", content_title: "Northern Lines", category_name: "Series Marathons", availability: "All Customers"},
        {playlist_order: 2, content_type: "Series", content_id: "SR-552", content_title: "Firelight", category_name: "Series Marathons", availability: "All Customers"},
        {playlist_order: 3, content_type: "Series", content_id: "SR-553", content_title: "Blue Harbor", category_name: "Series Marathons", availability: "All Customers"}
    ],
    150: [
        {playlist_order: 1, content_type: "Live Event", content_id: "EV-600", content_title: "Boxing Archive Alpha", category_name: "Featured Events", availability: "Legacy PPV"}
    ]
};

const playlistOrderingRows = {
    101: [
        {slot: 1, title: "Athens Derby Countdown", ordering_rule: "Pinned", start_window: "2026-03-14 18:00"},
        {slot: 2, title: "UEFA Late Match Highlights", ordering_rule: "Manual", start_window: "2026-03-14 20:00"},
        {slot: 3, title: "NBA Weekly Top Plays", ordering_rule: "Manual", start_window: "2026-03-15 09:00"}
    ],
    102: [
        {slot: 1, title: "Friday Main Card", ordering_rule: "Scheduled", start_window: "2026-03-20 21:00"},
        {slot: 2, title: "Prelims Replay", ordering_rule: "Scheduled", start_window: "2026-03-20 19:00"},
        {slot: 3, title: "Fighter Interviews", ordering_rule: "Fallback", start_window: "2026-03-19 09:00"}
    ],
    103: [
        {slot: 1, title: "The Sound of Winter", ordering_rule: "Editorial", start_window: "Always On"},
        {slot: 2, title: "Midnight Harbor", ordering_rule: "Editorial", start_window: "Always On"},
        {slot: 3, title: "Glass City", ordering_rule: "Editorial", start_window: "Always On"}
    ],
    104: [
        {slot: 1, title: "Northern Lines", ordering_rule: "Popularity", start_window: "Always On"},
        {slot: 2, title: "Firelight", ordering_rule: "Popularity", start_window: "Always On"},
        {slot: 3, title: "Blue Harbor", ordering_rule: "Popularity", start_window: "Always On"}
    ],
    150: [
        {slot: 1, title: "Boxing Archive Alpha", ordering_rule: "Manual", start_window: "Archive"}
    ]
};

const findOptionLabel = (options, value) => {
    const option = options.find((entry) => entry.value === value);
    return option ? option.label : value;
};

const buildCategoryNames = (playlistCategoryIds = []) => {
    return activePlaylistCategoryRows
        .concat(removedPlaylistCategoryRows)
        .filter((category) => playlistCategoryIds.includes(category.playlist_category_id))
        .map((category) => category.playlist_category_name);
};

const hydratePlaylistRecord = (record) => ({
    ...record,
    playlist_category_names: buildCategoryNames(record.playlist_category_ids)
});

const defaultPlaylistDraft = () => ({
    playlist_id: "new",
    playlist_position: activePlaylistRows.length + 1,
    playlist_status: 1,
    playlist_name: "",
    playlist_slug: "",
    playlist_description: "",
    playlist_type: "sports",
    playlist_delivery: "hybrid",
    playlist_category_ids: [201],
    playlist_category_names: buildCategoryNames([201]),
    playlist_item_count: 0,
    playlist_viewership_mode: "packages",
    playlist_viewership_summary: "Select customer packages and viewership filters",
    playlist_geo_policy: "Global",
    playlist_device_targets: "Android TV, Web",
    playlist_sort_mode: "manual",
    playlist_max_items: 20,
    updated_at: "Not saved"
});

const defaultPlaylistCategoryDraft = () => ({
    playlist_category_id: "new",
    playlist_category_position: activePlaylistCategoryRows.length + 1,
    playlist_category_status: 1,
    playlist_category_name: "",
    playlist_category_description: "",
    playlist_type: "sports",
    playlist_category_scope: "global",
    playlist_count: 0
});

const allPlaylistRows = activePlaylistRows.concat(removedPlaylistRows).map(hydratePlaylistRecord);
const allPlaylistCategoryRows = activePlaylistCategoryRows.concat(removedPlaylistCategoryRows);
const activePlaylistScaffoldRows = activePlaylistRows.map(hydratePlaylistRecord);
const removedPlaylistScaffoldRows = removedPlaylistRows.map(hydratePlaylistRecord);

const buildPlaylistDraft = (handle) => {
    if (handle === "new") {
        return defaultPlaylistDraft();
    }

    const match = allPlaylistRows.find((playlist) => String(playlist.playlist_id) === String(handle));
    return match ? {...match} : defaultPlaylistDraft();
};

const buildPlaylistCategoryDraft = (handle) => {
    if (handle === "new") {
        return defaultPlaylistCategoryDraft();
    }

    const match = allPlaylistCategoryRows.find((category) => String(category.playlist_category_id) === String(handle));
    return match ? {...match} : defaultPlaylistCategoryDraft();
};

const getPlaylistAssignmentRows = (playlistId) => {
    return playlistAssignments[playlistId] || [];
};

const getPlaylistOrderingRows = (playlistId) => {
    return playlistOrderingRows[playlistId] || [];
};

const getCategoryUsageRows = (categoryName) => {
    return allPlaylistRows.filter((playlist) => playlist.playlist_category_names.includes(categoryName));
};

const formatPlaylistType = (value) => findOptionLabel(playlistTypeOptions, value);
const formatPlaylistDelivery = (value) => findOptionLabel(playlistDeliveryOptions, value);
const formatViewershipMode = (value) => findOptionLabel(viewershipModeOptions, value);
const formatCategoryScope = (value) => findOptionLabel(categoryScopeOptions, value);

export {
    activePlaylistCategoryRows,
    activePlaylistScaffoldRows as activePlaylistRows,
    buildPlaylistCategoryDraft,
    buildPlaylistDraft,
    categoryScopeOptions,
    formatCategoryScope,
    formatPlaylistDelivery,
    formatPlaylistType,
    formatViewershipMode,
    getCategoryUsageRows,
    getPlaylistAssignmentRows,
    getPlaylistOrderingRows,
    playlistDeliveryOptions,
    playlistTypeOptions,
    removedPlaylistCategoryRows,
    removedPlaylistScaffoldRows as removedPlaylistRows,
    viewershipModeOptions
};
